import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';
import { ClickAwayListener, Popper } from '@mui/material';

import { ChannelActions, channelActionConfig } from '../../../utils/channelActions';
import ChatContext from '../../../context/ChatContext';
import ChatChannelContext from '../../../context/ChatChannelContext';
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';
import { Event } from '../../../utils/events';
import ChannelActionPopover from '../ChannelActionPopover';
import texts from './texts.json';

const ChannelActionMenu = ({
  anchorEl,
  setAnchorEl,
  isPopperOpen,
  setIsPopperOpen,
  selectedBucket,
  channel,
}) => {
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [selectedActionType, setSelectedActionType] = useState();
  const {
    authUser,
    logEvent,
  } = useContext(ChatContext);
  const {
    unreadCountDoc,
    activeChannel,
    resetChannelState,
  } = useContext(ChatChannelContext);

  const logData = { channelId: activeChannel?.id || '', actionedBy: authUser.id };

  const channelActionHandler = {
    [ChannelActions.ARCHIVE]: async () => {
      if (unreadCountDoc && unreadCountDoc.unreadCount) {
        await unreadCountDoc.setUnreadCountToZero();
      }
      channel.archive(authUser.id);
      logEvent(Event.ARCHIVE_CHANNEL, logData);
    },
    [ChannelActions.UNARCHIVE]: () => {
      channel.unarchive(authUser.id);
      logEvent(Event.UNARCHIVE_CHANNEL, logData);
    },
    [ChannelActions.HIDE]: () => {
      channel.hide(authUser.id);
      logEvent(Event.HIDE_CHANNEL, logData);
    },
    [ChannelActions.SHOW]: () => {
      channel.show(authUser.id);
      logEvent(Event.SHOW_CHANNEL, logData);
    },
  };

  const handleAlertAction = () => {
    channelActionHandler[selectedActionType]();
    setIsAlertOpen(false);
    // reset the active channel on action
    if (activeChannel?.id === channel.id) {
      resetChannelState();
    }
  };

  const handlePopoverAction = (type) => {
    setIsPopperOpen(false);
    setAnchorEl(null);

    if (type === ChannelActions.ARCHIVE) {
      channelActionHandler[ChannelActions.ARCHIVE]();
      if (activeChannel?.id === channel.id) {
        resetChannelState();
      }
      return;
    }

    setSelectedActionType(type);
    setIsAlertOpen(true);
  };
  return (
    <>
      <Popper
        style={{ zIndex: 1000 }}
        open={isPopperOpen}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        placement="bottom-end"
      >
        <ClickAwayListener onClickAway={() => setIsPopperOpen(false)}>
          <ChannelActionPopover
            selectedBucket={selectedBucket}
            handleAction={handlePopoverAction}
          />
        </ClickAwayListener>
      </Popper>
      {selectedActionType && (
        <ConfirmDialog
          isOpen={isAlertOpen}
          onConfirm={handleAlertAction}
          onCancel={() => setIsAlertOpen(false)}
          dialogTexts={{
            title: channelActionConfig[selectedActionType].alert.header,
            content: format(channelActionConfig[selectedActionType].alert.message, { channelName: channel.name }),
            confirm: texts.confirmButton,
            cancel: texts.cancelButton,
          }}
        />
      )}
    </>
  );
};

ChannelActionMenu.propTypes = {
  anchorEl: PropTypes.object,
  setAnchorEl: PropTypes.func,
  isPopperOpen: PropTypes.bool,
  setIsPopperOpen: PropTypes.func,
  selectedBucket: PropTypes.string,
  channel: PropTypes.object,
};

ChannelActionMenu.defaultProps = {
  anchorEl: null,
  setAnchorEl: () => { },
  isPopperOpen: false,
  setIsPopperOpen: () => { },
  selectedBucket: '',
  channel: {},
};

export default ChannelActionMenu;
